import React from 'react'
import { FormBuilderContainer } from '../../../components/formBuilder/formBuilder.container'
import { FormItemTypes, IFormBuilder, ValueTypes } from '../../../components/formBuilder/formBuilder.entity'

import { getApplicationList, ListKeys } from '../../../api/list'
import { useParams } from 'react-router-dom'
import { createRole, getRolebyId, updateRole } from './apiCall'
import { RoleKeys } from './entity'
import { getLocalStorageItem } from '../../../utils/storageHelper'

function RoleEdit() {
  let { id, mode } = useParams();
  if (!mode) mode = id ? 'edit' : 'add';

  const formData: IFormBuilder['formData'] = [
    {
      type: FormItemTypes.TextInput,
      name: 'Name',
      label: 'Name',
      value: null,
      required: true,
      maxLength: 100,
      valueTypes: ValueTypes.onlyAlphabets
    },
    {
      type: FormItemTypes.TextInput,
      name: 'DisplayName',
      label: 'Display Name',
      value: null,
      required: true,
      maxLength: 100,
      valueTypes: ValueTypes.onlyAlphabets
    },
    {
      type: FormItemTypes.SearchSelect,
      name: 'ApplicationId',
      label: 'Application',
      value: getLocalStorageItem('ApplicationId'),
      displayExpr: "DisplayName",
      valueExpr: "ApplicationId",
      getListData: getApplicationList,
      apiKey: ListKeys.applications,
      required: true,
      disabled: true
    },
    {
      type: FormItemTypes.TextInput,
      name: 'Description',
      label: 'Description',
      value: null,
      multiline: true,
      rows: 4,
      maxLength: 400,
      md: 6
    },
  ]

  return (
    <FormBuilderContainer
      formData={formData}
      mode={mode as IFormBuilder["mode"] || 'edit'}

      getFormAPI={getRolebyId}
      getRequest={{ id: id }}
      getKey={RoleKeys.get}

      createFormAPI={createRole}
      createKey={RoleKeys.create}

      updateFormAPI={updateRole}
      updateKey={RoleKeys.update}

      parentPath='/role'
      headerLabel={mode === 'add' ? 'Add Role' : 'Role'}
    />
  )
}

export default RoleEdit